module.exports = __webpack_public_path__ + "img/massage.2c1cfccc.png";